/**
 * Constants for pickup shop statuses
 */
module.exports = {
  DISABLED: 0,
  INCOMPLETE: 1,
  ACTIVE: 2,
  TEMPORARILY_DISABLED: 3,
};
